import styled from 'styled-components';
import { Flex } from '..';
import { getColor } from '../../styles/mixins';

export const Root = styled(Flex)`
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: ${getColor('gray', 0)};
`;

export const LoaderBody = styled(Flex)`
  position: relative;
  width: 300px;
  min-height: 8px;
  padding: 0;
  margin: 0;

  &:before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 300px;
    min-height: 8px;
    background-color: ${getColor('purple', 200)};
    border-radius: 4px;
  }

  &:after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 30px;
    min-height: 8px;
    background-color: ${getColor('purple')};
    animation: load 1.5s linear infinite;
    border-radius: 4px;
  }

  @keyframes load {
    0% {
      left: 0;
      width: 0px;
    }
    50% {
      left: 150px;
      width: 150px;
    }
    100% {
      left: 300px;
      width: 0px;
    }
  }
`;
